import {
    Component,
    OnInit
} from '@angular/core';
import {
    Constants
} from '../Services/Constants';
import {
    HTTPService
} from '../Services/http.service';
import {
    Observable
} from 'rxjs/Observable';
import {
    filter
} from '../App/search.pipe';
import {
    DatePipe
} from "@angular/common";
import {
    MySharedService
} from '../App/shared.service';
import {
    ActivatedRoute,
    Router
} from '@angular/router';



declare function ExportToExcel(item: any[], workSheetName: string, keys: any, Columns ? : any): void;

@Component({
    templateUrl: './AppViews/Vendors/vendorsEdit.html'
})

export class VendorEditComponent {
    public editVendordata: any = {};
    VendorGrades: any;
    userDetail: any;
    PaymentType: any;
    StausOrg: any;
    CountryInfo: any;
    VendorId: any;
    Vendors: any = [];
    PaymentMode: any;
    cityData: any = [];
    stateData: any = [];
    public constants: Constants;
    public showLoader = false;
    public isFormSubmitted: boolean = false;
    constructor(private _httpService: HTTPService, private route: ActivatedRoute, private _route: Router, private _sharedService: MySharedService) {
        this.route
            .params
            .subscribe(
                data => {
                    this.VendorId = data["vendorId"];
                    // this.IsCommercialEdit = data["Com"];
                })
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
    }

    ngOnInit() {
        this.getVendorGrades();
        this.getPaymentType();
        this.getorganizationStatus();
        this.getPaymentMode();
        this.getCountry();
        this.getVendors();
        this.GetCityData();
        this.GetStateData();

        $('.registration-form fieldset:first-child').fadeIn();

        $('#top-navbar-1').on('shown.bs.collapse', function () {
            //$.backstretch("resize");
        });
        $('#top-navbar-1').on('hidden.bs.collapse', function () {
            //$.backstretch("resize");
        });

        /*
            Form
        */
        $('.registration-form fieldset:first-child').fadeIn();

        $('.registration-form input[type="text"], .registration-form input[type="password"], .registration-form textarea').on('focus', function () {
            $(this).removeClass('input-error');
        });

        // next step
        $('.registration-form .btn-next').on('click', function () {
            var parent_fieldset = $(this).parents('fieldset');
            var next_step = true;

            parent_fieldset.find('input[id="form-Name"],input[id="form-Address"],input[id="form-PinCode"],input[id="Country"],input[id="form-Pname"],input[id="form-Phone"],input[id="form-Mobile"],input[id="form-Email"], textarea').each(function () {
                if ($(this).val() == "") {
                    $(this).addClass('input-error');
                    next_step = false;
                } else {
                    $(this).removeClass('input-error');
                }
            });

            if (next_step) {
                parent_fieldset.fadeOut(400, function () {
                    $(this).next().fadeIn();
                });
            }

        });

        // previous step
        $('.registration-form .btn-previous').on('click', function () {
            $(this).parents('fieldset').fadeOut(400, function () {
                $(this).prev().fadeIn();
            });
        });

        // submit
        $('.registration-form').on('submit', function (e) {

            $(this).find('input[type="text"], input[type="password"], textarea').each(function () {
                if ($(this).val() == "") {
                    e.preventDefault();
                    $(this).addClass('input-error');
                } else {
                    $(this).removeClass('input-error');
                }
            });

        });
    }

    validation(form: any) {
        this.isFormSubmitted = true;
    }

    GetCityData() {
        this._httpService.ajaxPost('Common/GetCity').subscribe(
            data => {
                this.cityData = data["Cities"];
            },
            err => {
                console.log("GetCityData Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }

    GetStateData() {
        this._httpService.ajaxPost('Common/GetState').subscribe(
            data => {
                this.stateData = data["States"];
            },
            err => {
                console.log("GetStateData Failed with status: " + err.status);
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);
            },
            () => {
                this.showLoader = false;
            }
        );
        setTimeout(function () {
            $(".pop-comment").popover({
                //content: 'test'
                content: function () {
                    return $(this).parent().find('p').html();
                }
            });
        }, 500);
    }


    public getVendorGrades() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["VendorGrade"]
        }).subscribe(
            data => {
                this.VendorGrades = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getPaymentType() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["Currency"]
        }).subscribe(
            data => {
                this.PaymentType = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getPaymentMode() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["PaymentMode"]
        }).subscribe(
            data => {
                this.PaymentMode = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getorganizationStatus() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["OrganizationStatus"]
        }).subscribe(
            data => {
                this.StausOrg = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getCountry() {
        this.showLoader = true;
        this._httpService.ajaxPost('Common/GetParameter', {
            "ParameterTypeId": this.constants.enumParamterTypeName["Country"]
        }).subscribe(
            data => {
                this.CountryInfo = data["Parameter"];
            },
            err => {
                this.showLoader = false;
            },
            () => {
                this.showLoader = false;
            }
        );
    }

    public getVendors() {
        this.showLoader = true;
        this._httpService.ajaxPost('Vendors/GetVendors', {
            "VendorId": this.VendorId,
            "IsActive": null
        }).subscribe(
            data => {
                this.Vendors = data["Vendors"];
                //   console.log(this.customers);
                this.EditVendor(this.Vendors[0]);
            },
            err => {
                this.showLoader = false;
            },

            () => {
                this.showLoader = false;
            }
        );
    }


    public EditVendor(item: any) {

        this.EditVendorChange(item.VendorId);

    }
    public EditVendorChange(itemId) {
        let objItem: any = {};
        objItem = JSON.parse(JSON.stringify(this.Vendors.filter((Vendors) => Vendors.VendorId == itemId)[0]));
        this.editVendordata.VendorId = objItem.VendorId;
        this.editVendordata.VendorName = objItem.CompanyName;
        this.editVendordata.VendorAddress = objItem.Address;
        this.editVendordata.Pincode = objItem.Pincode;
        this.editVendordata.Country = objItem.Country;
        this.editVendordata.Contactname = objItem.ContactPerson;
        this.editVendordata.Phone = objItem.Phone;
        this.editVendordata.Mobile = objItem.MobileNo;
        this.editVendordata.Email = objItem.Email;
        this.editVendordata.AltEmail = objItem.AlternateEmail;
        this.editVendordata.Status = objItem.StatusOfOrganisation;
        this.editVendordata.BankName = objItem.BankName;
        this.editVendordata.BankAccountNo = objItem.BankAccountNumber;
        this.editVendordata.IFSC = objItem.IFSCCode;
        this.editVendordata.PaymentType = objItem.Currency;
        this.editVendordata.Swift = objItem.SwiftCode;
        this.editVendordata.Credit = objItem.PaymentCredit;
        this.editVendordata.PaymentMode = objItem.PaymentMode;
        this.editVendordata.PAN = objItem.PanCardNumber;
        this.editVendordata.VAT = objItem.VATNo;
        this.editVendordata.CST = objItem.CSTNo;
        this.editVendordata.Tax = objItem.ServiceTaxNumber;
        this.editVendordata.GST = objItem.GSTNo;
        this.editVendordata.Grades = objItem.GradeId;
        this.editVendordata.editVendorIsActive = objItem.Is_Active;
        this.editVendordata.City = objItem.CityId;
        this.editVendordata.State = objItem.StateId;
        //  null = objItem.Is_Active ;
    }

    public UpdateCustomer() {

        let objItem: any = {};
        objItem.VendorId = this.VendorId;
        objItem.CompanyName = this.editVendordata.VendorName;
        objItem.Address = this.editVendordata.VendorAddress;
        objItem.Pincode = this.editVendordata.Pincode;
        objItem.Country = parseInt(this.editVendordata.Country);
        objItem.ContactPerson = this.editVendordata.Contactname
        objItem.Phone = this.editVendordata.Phone;
        objItem.MobileNo = this.editVendordata.Mobile;
        objItem.Email = this.editVendordata.Email;
        if (this.editVendordata.AltEmail != undefined) {
            objItem.AlternateEmail = this.editVendordata.AltEmail;
        } else {
            objItem.AlternateEmail = null;

        }
        //  objItem.AlternateEmail = this.editVendordata.AltEmail;
        objItem.StatusOfOrganisation = this.editVendordata.Status;
        objItem.BankName = this.editVendordata.BankName;
        objItem.BankAccountNumber = this.editVendordata.BankAccountNo;
        objItem.IFSCCode = this.editVendordata.IFSC;
        objItem.Currency = parseInt(this.editVendordata.PaymentType);
        objItem.SwiftCode = this.editVendordata.Swift;
        if (this.editVendordata.Credit != undefined) {
            objItem.PaymentCredit = this.editVendordata.Credit;
        } else {
            objItem.PaymentCredit = null;
        }
        objItem.PaymentMode = parseInt(this.editVendordata.PaymentMode);
        objItem.PanCardNumber = this.editVendordata.PAN;
        if (this.editVendordata.VAT != undefined) {
            objItem.VATNo = this.editVendordata.VAT;
        } else {
            objItem.VATNo = null;
        }
        if (this.editVendordata.CST != undefined) {
            objItem.CSTNo = this.editVendordata.CST;
        } else {
            objItem.CSTNo = null;

        }
        if (this.editVendordata.Tax != undefined) {
            objItem.ServiceTaxNumber = this.editVendordata.Tax;
        } else {
            objItem.ServiceTaxNumber = null;
        }

        objItem.GSTNo = this.editVendordata.GST;
        objItem.GradeId = this.editVendordata.Grades;
        objItem.Is_Active = this.editVendordata.editVendorIsActive;
        objItem.CityId = this.editVendordata.City;
        objItem.StateId = this.editVendordata.State;
        this.addEditVendors(objItem);

    }


    navigate() {
        this._route.navigateByUrl("/vendors");
    }

    addEditVendors(objItem) {
        this.showLoader = true;
        console.log(objItem);
        this._httpService.ajaxPost('Vendors/AddUpdateVendors', objItem).subscribe(
            data => {

                var msg = data["Status"].Message.split('|');
                if (msg.length > 1) {
                    msg[0] = msg[0].toLowerCase();
                    this._sharedService.ShowMessage(data["Status"].Message);
                    this.navigate()
                } else {
                    this._sharedService.ShowMessage(data["Status"].Message);
                }
            },
            err => {
                this.showLoader = false;
                this._sharedService.ShowMessage(this.constants.globalError);

            },

            () => {
                this.showLoader = false;

            }
        );
    }

    public autoSelectState(isEdit: boolean) {
        if (this.editVendordata.City)
            this.editVendordata.State = this.cityData.filter((city) => city.CityId == this.editVendordata.City)[0].StateId;
    }


}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Vendors/VendorEdit.component.ts
 **/